import {
  Grid,
  Link,
  Button,
  Typography,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import React, { Component } from "react";
import { MyPATDialog, MyPATSelect, MyPATTextField } from "../../common";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { ContentOwnersStyle } from "../styles/ContentOwnersStyle";
import { SubQuestionsPassage } from "../types/ContentRequest";
import { onlyAllowNumbers } from "../../../utils";
import { QUESTION_TYPES } from "../../../constants/comman";

interface Props extends WithStyles<typeof ContentOwnersStyle> {
  onClose: () => void;
  subQuestionsData: {
    passage: SubQuestionsPassage[];
    count: string | number;
  };
  onDone: (subQuestionsData: any) => void;
}

interface State {
  count: string | number;
  passage: SubQuestionsPassage[];
}

class SubQuestionsPopup extends Component<Props, State> {
  state: State = {
    count: this.props.subQuestionsData.count,
    passage: this.props.subQuestionsData.passage,
  };
  handleParagraphCount = (count: number | string) => {
    this.setState((prevState) => {
      let newPassages = [...prevState.passage];
      if (!count) {
        newPassages = [];
      } else {
        const parsedCount = parseInt(count.toString());
        if (parsedCount > newPassages.length) {
          const diff = parsedCount - newPassages.length;
          const newPassageData = this.generateEmptyPassageData(diff);
          newPassages = newPassages.concat(newPassageData);
        } else if (count) {
          newPassages = newPassages.slice(0, parsedCount);
        }
      }
      return {
        ...prevState,
        passage: newPassages,
        count,
      };
    });
  };
  generateEmptyPassageData = (requiredCount: number) => {
    let data = [];
    for (let i = 0; i < requiredCount; i++) {
      data.push(EMPTY_PASSAGE_DATA);
    }
    return data;
  };
  componentDidMount() {
    const {
      subQuestionsData: { count, passage },
    } = this.props;
    const parsedCount = parseInt(count.toString()) || 0;

    if (parsedCount > passage.length) {
      const newPassages = this.generateEmptyPassageData(
        parsedCount - passage.length
      );
      this.setState((prevState) => {
        return {
          ...prevState,
          passage: prevState.passage.concat(newPassages),
        };
      });
    }
  }
  handlePassageCodeEdit = (rowIndex: number, value: any) => {
    this.setState((prevState) => {
      const newPassages = [...prevState.passage];
      const newPassage = { ...newPassages[rowIndex] };

      newPassage.code = parseInt(value);
      let type = newPassage.type;
      // If code changes update the type as well
      if (value === QUESTION_TYPES.SMCQ.toString()) {
        type = "SMCQ";
      } else if (value === QUESTION_TYPES.MMCQ.toString()) {
        type = "MMCQ";
      } else if (value === QUESTION_TYPES.MATRIX.toString()) {
        type = "Matrix"
      }
      else if (value === QUESTION_TYPES.TRUE_FALSE.toString()) {
        type = "True & False"
      }
      else if (value === QUESTION_TYPES.BLANKS.toString()) {
        type = "Blanks"
      }
      else if (value === QUESTION_TYPES.INTEGER.toString()) {
        type = "Integer"
      }
      else if (value === QUESTION_TYPES.NUMERICAL.toString()) {
        type = "Numerical"
      }
      newPassage.type = type;

      newPassages[rowIndex] = newPassage;
      return {
        ...prevState,
        passage: newPassages,
      };
    });
  };
  handlePassageCountEdit = (rowIndex: number, value: any) => {
    this.setState((prevState) => {
      const newPassages = [...prevState.passage];
      const newPassage = { ...newPassages[rowIndex] };

      newPassage.count = value;

      newPassages[rowIndex] = newPassage;
      return {
        ...prevState,
        passage: newPassages,
      };
    });
  };
  handleDone = () => {
    this.props.onDone(this.state);
  };
  render() {
    const { classes, onClose } = this.props;
    const { count, passage } = this.state;
    return (
      <MyPATDialog
        dialogOpen={true}
        dialogHasActions={true}
        variantHeader="leftHeader"
        dialogHeading={
          <>
            <Grid style={{padding: '10px 0'}}>
              <Grid container justify="flex-start" alignItems="center">
                <Typography className={classes.dialogHeading}>Add Sub Question Details</Typography>
              </Grid>
              <Grid container justify="flex-start" alignItems="center">
                <Typography className={classes.dialogSubHeading}>Hey! Since you have selected paragraph type Question, you will have to specify the below details</Typography>
              </Grid>
            </Grid>
          </>
        }
        isAlignCenter={false}
        customButtonVariant="withoutBorderCloseIcon"
        onDialogClose={onClose}
        isCustomBackground={false}
        isborderDialogAction={true}
        otherDialogProps={{
          fullWidth: false,
          maxWidth: false,
        }}
        customDialogActions={
          <>
            <Grid
              container
              justify="flex-end"
              spacing={8}
              alignItems="center"
              className={classes.dialogActions}
            >
              <Grid item>
                <Link onClick={onClose}>Cancel</Link>
              </Grid>
              <Grid item>
                <Button
                  // onClick={this.handleDialogClose.bind(this)}
                  // disabled={isDisableRepublishAll}
                  // className={classes.okButton}
                  variant="contained"
                  color="primary"
                  onClick={this.handleDone}
                >
                  Done
                </Button>
              </Grid>
            </Grid>
          </>
        }
      >
        <Grid container className={classes.dialogContainer}>
          <Grid container justify="flex-start" alignItems="center">
            <Grid item>
              <Typography className={classes.normalHeading}>
                Specify Total Count Of Paragraph Type Questions :
              </Typography>
            </Grid>

            <Grid item>
              <Grid className={classes.inputContainer}>
                <Grid
                  className={classes.iconContainer}
                  onClick={() => {
                    if (!count || parseInt(count.toString()) === 1) {
                      return;
                    }
                    const newCount = parseInt(count.toString()) - 1;
                    this.handleParagraphCount(newCount);
                  }}
                >
                  <RemoveIcon />
                </Grid>
                <span className={classes.manageInputHeight}>
                  <MyPATTextField
                    fullWidthControl
                    inputId="count"
                    name="count"
                    value={count}
                    type="number"
                    onChange={(event: any) =>
                      this.handleParagraphCount(event.target.value)
                    }
                    onKeyPress={onlyAllowNumbers}
                    inputProps={{ min: 1 }}
                    endAdornment={<></>}
                  />
                </span>
                <Grid
                  className={classes.iconContainer}
                  onClick={() => {
                    let newCount = count ? parseInt(count.toString()) : 0;
                    newCount += 1;
                    this.handleParagraphCount(newCount);
                  }}
                >
                  <AddIcon />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <hr className={classes.borderTop}/>

          <Grid container spacing={16}>
            <Grid item xs={1} />
            <Grid item xs={7}>
              <Typography className={classes.normalText}>
                Add Sub Question Type
                <CustomInfoIcon
                  isInfoIcon={true}
                  isCenterArrow={true}
                  isRightArrow={false}
                  knowMoreAbout={false}
                  dialogTitle="Share Content"
                  dialogPara="Sample Text"
                  imageURL="/assets/svg/infoIcon/share.svg"
                  htmlElement=""
                  toolTipDirection="top"
                  details="Click to know more"
                />
              </Typography>
            </Grid>

            <Grid item xs={4}>
              <Grid container justify="flex-end">
                <Typography className={classes.normalText}>
                  Add Sub-Question Quantity
                  <CustomInfoIcon
                    isInfoIcon={true}
                    // isCenterArrow={true}
                    isRightArrow={true}
                    knowMoreAbout={false}
                    dialogTitle="Share Content"
                    dialogPara="Sample Text"
                    imageURL="/assets/svg/infoIcon/share.svg"
                    htmlElement=""
                    toolTipDirection="top"
                    details="Click to know more"
                  />
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {passage.map(({ count, type, code }, index) => {
            return (
              <Grid container justify="flex-start" alignItems="center" key={index}>
                <Grid item xs={1}>
                  <h4>Q{index + 1}.</h4>
                </Grid>
                <Grid item xs={7}>
                  <MyPATSelect
                    fullWidthControl
                    fullwidth={true}
                    required
                    onChange={(event: any) =>
                      this.handlePassageCodeEdit(index, event.target.value)
                    }
                    label=""
                    inputId="code"
                    name="code"
                    value={code}
                  >
                    <option value={QUESTION_TYPES.SMCQ.toString()}>SMCQ</option>
                    <option value={QUESTION_TYPES.MMCQ.toString()}>MMCQ</option>
                    <option value={QUESTION_TYPES.MATRIX.toString()}>Matrix</option>
                    <option value={QUESTION_TYPES.TRUE_FALSE.toString()}>True & False</option>
                    <option value={QUESTION_TYPES.BLANKS.toString()}>Blanks</option>
                    <option value={QUESTION_TYPES.NUMERICAL.toString()}>Numerical</option>
                    <option value={QUESTION_TYPES.INTEGER.toString()}>Integer</option>
                  </MyPATSelect>
                </Grid>
                <Grid item xs={4}>
                  <Grid container justify="flex-end">
                    <Grid className={classes.inputContainer}>
                      <Grid
                        className={classes.iconContainer}
                        onClick={() => {
                          const { count } = passage[index];
                          const parsedCount = parseInt(count.toString()) || 0;
                          if (parsedCount < 3) {
                            return;
                          }
                          this.handlePassageCountEdit(index, parsedCount - 1);
                        }}
                      >
                        <RemoveIcon />
                      </Grid>
                      <span className={classes.manageInputHeight}>
                        <MyPATTextField
                          fullWidthControl
                          inputId="row-count"
                          name="row-count"
                          value={passage[index].count}
                          type="number"
                          onChange={(event: any) => {
                            const parsedValue = parseInt(event.target.value) || 0;
                            if(parsedValue > 5) {
                              return;
                            }
                            this.handlePassageCountEdit(index, event.target.value)
                          }
                            
                          }
                          onKeyPress={onlyAllowNumbers}
                          inputProps={{ min: 2, max: 5 }}
                          endAdornment={<></>}
                        />
                      </span>
                      <Grid
                        className={classes.iconContainer}
                        onClick={() => {
                          const { count } = passage[index];
                          const parsedCount = parseInt(count.toString()) || 0;
                          const newCount = parsedCount + 1;
                          if(newCount > 5) {
                            return;
                          }
                          this.handlePassageCountEdit(index, newCount);
                        }}
                      >
                        <AddIcon />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </MyPATDialog>
    );
  }
}

export const EMPTY_PASSAGE_DATA: SubQuestionsPassage = {
  code: 0,
  count: 2,
  type: "SMCQ",
};

export default withStyles(ContentOwnersStyle)(SubQuestionsPopup);
